import { getTheBoolean, select } from 'src/store/selectors/utils'

const getBuyerUnsubscribe = state => state.buyerUnsubscribe
const selectFromBuyerUnsubscribe = select(getBuyerUnsubscribe)

export const selectBuyerUnsubscribeRequested = selectFromBuyerUnsubscribe(
  getTheBoolean('requested')
)
